import { render, staticRenderFns } from "./invoicing.vue?vue&type=template&id=0d0e47b8&scoped=true"
import script from "./invoicing.vue?vue&type=script&lang=js"
export * from "./invoicing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0e47b8",
  null
  
)

export default component.exports